// src/api/client.js
const RAW_API_URL = process.env.REACT_APP_API_URL || '';
export const API_URL = RAW_API_URL.replace(/\/$/, '');

export const authFetch = (path, options = {}) => {
  const token = localStorage.getItem('auth_token') || '';
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const url = path.startsWith('http')
    ? path
    : `${API_URL}${path.startsWith('/') ? '' : '/'}${path}`;
  return fetch(url, { ...options, headers, credentials: 'include' });
};
